var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "registerScreen" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row --mainRow" }, [
            _c("div", {
              staticClass:
                "col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"
            }),
            _vm._v(" "),
            _vm.canAdopt
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol"
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "paddingBox" }, [
                      _c("h2", [_vm._v("Údaje kravičky na adopciu")]),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-7 col-xl-7" }, [
                          _c("form", { on: { submit: _vm.formSubmit } }, [
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-12 col-md-12" }, [
                                _c("label", [_vm._v("Meno kravičky")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.kravicka_meno,
                                      expression: "kravicka_meno"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Daj meno svojej kravičke",
                                    required: ""
                                  },
                                  domProps: { value: _vm.kravicka_meno },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.kravicka_meno = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-12 col-md-12" }, [
                                _c("label", [_vm._v("Meno majiteľa kravičky")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.kravicka_meno_rodica,
                                      expression: "kravicka_meno_rodica"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder:
                                      "Meno adoptívneho rodiča / kolektívu",
                                    required: ""
                                  },
                                  domProps: { value: _vm.kravicka_meno_rodica },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.kravicka_meno_rodica =
                                        $event.target.value
                                    }
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-12 col-md-12" }, [
                                _vm.kravicka_status == 0
                                  ? _c(
                                      "button",
                                      { staticClass: "btn --primary w-100" },
                                      [
                                        _vm._v(
                                          "\n                                                    Pokračovať ďalej"
                                        ),
                                        _c("span", {
                                          staticClass: "icon --angleIcon"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-5 col-xl-5" }, [
                          _c("aside", { staticClass: "o-widget mb-md-5" }, [
                            _c("div", { staticClass: "m-widgetContent" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("dl", [
                                _c("dt", [_vm._v("Číslo kravičky")]),
                                _vm._v(" "),
                                _c("dd", [_vm._v(_vm._s(_vm.kravicka_cislo))]),
                                _vm._v(" "),
                                _c("dt", [_vm._v("Farma")]),
                                _vm._v(" "),
                                _c("dd", [_vm._v(_vm._s(_vm.kravicka_dvor))]),
                                _vm._v(" "),
                                _c("dt", [_vm._v("Dátum narodenia")]),
                                _vm._v(" "),
                                _c("dd", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("moment")(
                                        _vm.kravicka_datum,
                                        "D.M.YYYY"
                                      )
                                    )
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol"
                  },
                  [
                    _vm._v(
                      "\n                        Už máte adoptovanú kravičku, ďalšiu nie je možné adoptovať.\n                    "
                    )
                  ]
                )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "m-stepNavigation" }, [
      _c("li", { staticClass: "a-stepNavigation__item is-done mb-2 mb-md-0" }, [
        _vm._v("VÝBER KRAVIČKY")
      ]),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "a-stepNavigation__item is-active mb-2 mb-md-0" },
        [_vm._v("ÚDAJE KRAVIČKY")]
      ),
      _vm._v(" "),
      _c("li", { staticClass: "a-stepNavigation__item" }, [_vm._v("EAN KÓDY")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widgetContent__description" }, [
      _c("p", [
        _vm._v(
          "Daj meno svojej kravičke a vyplň aj svoje meno, alebo meno koho bude kravička po adopcii, alebo názov triedy - kolektívu kto si kravičku adoptuje. Meno kravičky aj meno majiteľa kravičky bude potom uvedené na Rodnom liste kravičky."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }